/*
===============================================================================================================
                                 Copyright 2021-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { AuthContext } from '@/contexts/auth-context';

function RootPage() {
  const router = useRouter();
  const { isUserLoggedIn, loggedInCompanyId, externalAuthProvider } = useContext(AuthContext);

  const newRoute = isUserLoggedIn ? '/merchants/overview' : '/login';

  if (externalAuthProvider?.isWidgetLogin && isUserLoggedIn && loggedInCompanyId) {
    router.push(`/${loggedInCompanyId}/customise`);
  } else {
    router.push(newRoute);
  }
  return <></>;
}

export default RootPage;
